import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { TemplateGroupModel } from '@models/types'

interface TemplateGroupProps {
  callbacks?: {
    onClick: () => void,
  },
  entity: TemplateGroupModel,
  selected: boolean,
}

const TemplateGroup = (props: TemplateGroupProps) => {
  const {
    callbacks,
    entity: { id, title },
    selected,
  } = props

  const { onClick } = callbacks || {}

  return (
    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>
  )
}

export default TemplateGroup
